import React, { useRef } from "react";

import Box from "@mui/material/Box";

import { v4 as uuidv4 } from "uuid";
import { useGoogleLogin } from "@react-oauth/google";

import { useAppSelector } from "store/hooks";

import GoogleButton from "./GoogleButton";
import FacebookButton from "./FacebookButton";

import authService, { AuthKeys } from "services/auth";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

export enum AppButtonMode {
  Register = "register",
  Login = "login",
}

interface AppButtonsProps {
  mode?: AppButtonMode;
  from?: string;
}

const AppButtons: React.FC<AppButtonsProps> = () => {
  const isDisabled = useAppSelector((state) => state.auth.isLoading);
  const isSocialMediaLoading = useAppSelector(
    (state) => state.auth.isSocialMediaLoading,
  );

  const stateRef = useRef(uuidv4());
  const googleLogin = useGoogleLogin({
    flow: "auth-code",
    ux_mode: "redirect",
    redirect_uri: `${window.location.origin}/auth/google/callback`,
    state: stateRef.current,
    scope: "openid email profile",
  });

  const onGoogleLogin = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.auth_google_btn_click,
      null,
      true,
    );

    sessionStorage.setItem(AuthKeys.GOOGLE_STATE, stateRef.current);
    googleLogin();
  };
  const onFacebookLogin = () => {
    analytics().sendConversionEvent(
      AnalyticsEvents.auth_facebook_btn_click,
      null,
      true,
    );

    authService().handleFacebookLogin();
  };

  return (
    <Box
      sx={{
        width: "100%",
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <GoogleButton
        onClick={onGoogleLogin}
        disabled={isDisabled}
        loading={isSocialMediaLoading}
      />
      <FacebookButton
        onClick={onFacebookLogin}
        disabled={isDisabled}
        loading={isSocialMediaLoading}
      />
    </Box>
  );
};

export default AppButtons;
